import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import { BiX } from 'react-icons/bi';
import { GoDash, GoPlus } from 'react-icons/go';

import Button from '../../../../newComponents/Button';
import Complement from '../Complement';

import * as S from './styles';
import * as SM from '../ModalProduct/styles';

import { formateBrPrice } from '../../../../utils/formateBrPrice';
import TextArea from '../../../../newComponents/TextArea';
import { IProduct } from '../../../../interfaces/IProduct';
import { ICartItem } from '../../../../interfaces/ICartItem';
import { IColor } from '../../../../interfaces/IColor';
import { ISize } from '../../../../interfaces/ISize';
import { ISelectedComplement } from '../ModalProduct';
import { IGrid } from '../../../../interfaces/IGrid';
import { calcOrderPrice } from '../../../../utils/calcOrderPrice';

export interface SizeForShow {
  name: string;
  estoque: any;
  ordem: number;
}

export interface ColorForShow {
  color: IColor;
  sizes: SizeForShow[];
}

interface GridProductProps {
  product: IProduct;
  onClose: () => void;
  itemToCart: (payload: Omit<ICartItem, 'id'>) => void;
  colorsAndSizesAll: {
    colors: IColor[] | null;
    sizes: ISize[] | null;
  };
  cartItem?: ICartItem;
}

export const GridProduct: React.FC<GridProductProps> = (props) => {
  const { onClose, product, itemToCart, cartItem, colorsAndSizesAll } = props;

  const [quantity, setQuantity] = useState(cartItem?.quantity ?? 1);
  const [price, setPrice] = useState(0);
  const [note, setNote] = useState(cartItem?.observation || '');
  const [selectedComplements, setSelectedComplements] = useState<
    ISelectedComplement[]
  >(() => {
    if (cartItem && cartItem.compositeProduct.complements.length > 0)
      return cartItem.compositeProduct.complements;

    return [];
  });
  const [groupsUnderMinimum, setGroupsUnderMinimum] = useState<
    { id: number; under: boolean }[]
  >([]);
  const [anyGroupUnder, setAnyGroupUnder] = useState(false);

  const [listColorWithSizes, setListColorWithSizes] = useState<ColorForShow[]>(
    [],
  );
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedColor, setSelectedColor] = useState<ColorForShow | null>(null);
  const [
    selectedProdutoGrade,
    setselectedProdutoGrade,
  ] = useState<IGrid | null>(null);

  const handleSelectedComplement = (
    cartComponent: ISelectedComplement,
  ): void => {
    const grupo = product.complements.find(
      (group) => cartComponent.complement.complementId === group.id,
    );

    if (!grupo) return;

    setSelectedComplements((old) => {
      let temp: ISelectedComplement[] = [];

      if (+grupo.maximumQuantity === 1) {
        temp = selectedComplements.filter(
          (item) =>
            item.complement.id !== cartComponent.complement.id &&
            item.complement.complementId !==
              cartComponent.complement.complementId,
        );
      } else {
        temp = selectedComplements.filter(
          (item) => item.complement.id !== cartComponent.complement.id,
        );
      }

      if (cartComponent.quantity > 0) temp.push(cartComponent);

      return temp;
    });
  };

  const handleAddItemToCart = (): void => {
    itemToCart({
      compositeProduct: {
        product,
        complements: selectedComplements,
      },
      childOrderItems: [],
      gridProduct: selectedProdutoGrade,
      quantity,
      observation: note,
    });

    onClose();
  };

  useEffect(() => {
    if (colorsAndSizesAll.colors !== null && colorsAndSizesAll.sizes !== null) {
      const tempColorIds = product.grids.map(
        (produtoGrade) => produtoGrade.colorId,
      );

      const tempColors = colorsAndSizesAll.colors.filter((color) =>
        tempColorIds.includes(color.id),
      );

      const tempColorsWithSizes = tempColors.map(
        (color): ColorForShow => {
          return {
            color,
            sizes: product.grids
              .filter((produtoGrade) => produtoGrade.colorId === color.id)
              .map(
                (produtoGrade): SizeForShow => {
                  const foundSize = colorsAndSizesAll.sizes?.find(
                    (size) => size.id === produtoGrade.sizeId,
                  );

                  return {
                    name: foundSize?.name ?? '',
                    // estoque: produtoGrade.stock,
                    estoque: 1,
                    ordem: foundSize?.order || 0,
                  };
                },
              ),
          };
        },
      );

      setListColorWithSizes(tempColorsWithSizes);

      if (cartItem?.gridProduct) {
        const tempDefaultColor = tempColorsWithSizes.find(
          (color) => color.color.id === cartItem.gridProduct.colorId,
        );
        if (tempDefaultColor) setSelectedColor(tempDefaultColor);

        const foundSize = colorsAndSizesAll.sizes?.find(
          (size) => size.id === cartItem.gridProduct.sizeId,
        );

        setSelectedSize(foundSize?.name ?? '');
      } else {
        product.grids.forEach((produtoGrade) => {
          if (
            product.minGridsPrice ===
            Number(produtoGrade.price?.value || 0) -
              Number(produtoGrade.discount?.price || 0)
          ) {
            const tempDefaultColor = tempColorsWithSizes.find(
              (color) => color.color.id === produtoGrade.colorId,
            );

            if (tempDefaultColor) setSelectedColor(tempDefaultColor);

            const foundSize = colorsAndSizesAll.sizes?.find(
              (size) => size.id === produtoGrade.sizeId,
            );

            setSelectedSize(foundSize?.name ?? '');
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorsAndSizesAll]);

  useEffect(() => {
    if (selectedProdutoGrade) {
      const { stock } = selectedProdutoGrade;
      if (
        stock &&
        stock.ativo &&
        stock.estoque_atual < quantity &&
        stock.estoque_atual > 0
      ) {
        setQuantity(+stock.estoque_atual);
      }
    }
    setQuantity(cartItem?.quantity ?? 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProdutoGrade]);

  useEffect(() => {
    if (product && selectedProdutoGrade) {
      setPrice(
        calcOrderPrice({
          id: product.id,
          compositeProduct: {
            product,
            complements: selectedComplements,
          },
          childOrderItems: [],
          gridProduct: selectedProdutoGrade,
          quantity,
          observation: note,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity, selectedComplements, product, selectedProdutoGrade]);

  useEffect(() => {
    product.complements.forEach((comp) => {
      if (groupsUnderMinimum !== undefined) {
        const tempGroupsUnder = groupsUnderMinimum;

        if (+comp.minimumQuantity > 0 && +comp.maximumQuantity > 1) {
          tempGroupsUnder.push({ id: comp.id, under: true });
        } else {
          tempGroupsUnder.push({ id: comp.id, under: false });
        }

        setGroupsUnderMinimum(tempGroupsUnder);
      } else if (+comp.minimumQuantity > 0 && +comp.maximumQuantity > 1) {
        setGroupsUnderMinimum([{ id: comp.id, under: true }]);
      } else {
        setGroupsUnderMinimum([{ id: comp.id, under: false }]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);

  useEffect(() => {
    let counter = 0;

    if (groupsUnderMinimum !== undefined) {
      groupsUnderMinimum.forEach((group) => {
        if (group.under) {
          setAnyGroupUnder(true);
        } else {
          counter += 1;
        }
      });

      if (counter === groupsUnderMinimum.length) {
        setAnyGroupUnder(false);
      }
    }
  }, [groupsUnderMinimum]);

  useEffect(() => {
    if (selectedColor) {
      const tempProdutoGrade = product.grids.find((produtoGrade) => {
        const foundSize = colorsAndSizesAll.sizes?.find(
          (size) => size.id === produtoGrade.sizeId,
        );

        const foundColor = colorsAndSizesAll.colors?.find(
          (color) => color.id === produtoGrade.colorId,
        );

        return (
          foundSize?.name === selectedSize &&
          foundColor?.id === selectedColor?.color.id
        );
      });

      if (tempProdutoGrade) setselectedProdutoGrade(tempProdutoGrade);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSize, selectedColor]);

  return (
    <div className="body">
      <div>
        <SM.ModalHeader>
          <h1>{product?.name}</h1>
          <button type="button" onClick={onClose}>
            <BiX />
          </button>
        </SM.ModalHeader>
        <SM.ModalBody>
          <h2>{product?.observation}</h2>

          {selectedProdutoGrade?.stock &&
            selectedProdutoGrade?.stock.active &&
            Number(selectedProdutoGrade?.stock.currentStock) === 0 && (
              <p className="out__of__stock">Sem Estoque</p>
            )}

          <div>
            <h3>
              COR
              {`${
                selectedColor?.color.name
                  ? ` - ${selectedColor?.color.name}`
                  : ''
              }`}
            </h3>
            <div className="colors">
              {listColorWithSizes
                .sort((a, b) => a.color.order - b.color.order)
                .map((colorWithSizes) => (
                  <S.Circle
                    key={colorWithSizes.color.id}
                    selected={
                      selectedColor?.color.id === colorWithSizes.color.id
                    }
                    color={colorWithSizes.color.hex}
                    onClick={() => {
                      setSelectedColor(colorWithSizes);
                      setSelectedSize(colorWithSizes.sizes[0].name);
                    }}
                  />
                ))}
            </div>
          </div>

          <S.CustomDivider />

          <div>
            <h3>TAMANHO</h3>
            <div className="sizes">
              {selectedColor?.color ? (
                (selectedColor ? selectedColor.sizes : [])
                  .sort((a, b) => a.ordem - b.ordem)
                  .map((size) => (
                    <S.Size
                      key={size.ordem}
                      selected={
                        selectedSize ? selectedSize === size.name : false
                      }
                      disabled={
                        size.estoque &&
                        size.estoque?.active &&
                        +size.estoque.currentStock === 0
                      }
                      onClick={() => setSelectedSize(size.name)}
                    >
                      <p>{size.name}</p>
                    </S.Size>
                  ))
              ) : (
                <p>Selecione uma cor</p>
              )}
            </div>
          </div>

          <S.CustomDivider />

          {product.complements
            .sort((a, b) => a.order - b.order)
            .map((complement) => (
              <Complement
                key={complement.id}
                cartComplement={cartItem?.compositeProduct.complements.find(
                  (comp) => comp.complement.complementId === complement.id,
                )}
                complement={complement}
                handleSelectedComplement={handleSelectedComplement}
                selectedComplements={selectedComplements}
                groupsUnderMinimum={groupsUnderMinimum}
                setGroupsUnderMinimum={setGroupsUnderMinimum}
              />
            ))}

          <div className="quantity">
            <SM.CustomIconButton
              size="small"
              disabled={quantity === 1}
              onClick={() => setQuantity(quantity - 1)}
            >
              <GoDash />
            </SM.CustomIconButton>
            <p>{quantity}</p>
            <SM.CustomIconButton
              size="small"
              disabled={
                !selectedProdutoGrade ||
                (selectedProdutoGrade?.stock &&
                  selectedProdutoGrade.stock.active &&
                  +selectedProdutoGrade.stock.currentStock <= quantity)
              }
              onClick={() => setQuantity(quantity + 1)}
            >
              <GoPlus />
            </SM.CustomIconButton>
          </div>
          <div className="comments">
            <TextArea
              value={note}
              placeholder="Observação"
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </SM.ModalBody>

        <SM.ModalFooter>
          <Button
            full
            disabled={
              anyGroupUnder ||
              !selectedProdutoGrade ||
              (selectedProdutoGrade?.stock &&
                selectedProdutoGrade.stock.active &&
                +selectedProdutoGrade.stock.currentStock < quantity)
            }
            onClick={handleAddItemToCart}
          >
            {`Adicionar ${formateBrPrice(+price)}`}
          </Button>
          <Button full variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
        </SM.ModalFooter>
      </div>
    </div>
  );
};
